import { DateOnly } from '@/api/common/common.models';

export const queryKeys = {
    authStatus: ['authStatus'] as const,
    customers: ['customers'] as const,
    customer: (id: string) => [...queryKeys.customers, id] as const,
    customerUsers: ['customerUsers'] as const,
    customerUser: (customerId: string, id: string) =>
        [...queryKeys.customerUsers, 'customer', customerId, id] as const,
    customerUsersByCustomer: (customerId: string) =>
        [...queryKeys.customerUsers, 'customer', customerId] as const,
    projects: ['projects'] as const,
    project: (id: string) => [...queryKeys.projects, id] as const,
    profitWarnings: ['profitWarnings'] as const,
    profitWarningsByProject: (projectId: string) =>
        [...queryKeys.profitWarnings, 'project', projectId] as const,
    projectTasks: ['projectTasks'] as const,
    projectTask: (projectId: string, id: string) =>
        [...queryKeys.projectTasks, 'project', projectId, id] as const,
    projectTasksByProject: (projectId: string) =>
        [...queryKeys.projectTasks, 'project', projectId] as const,
    preliminaries: ['preliminaries'] as const,
    preliminary: (projectId: string, id: string) =>
        [...queryKeys.preliminaries, 'project', projectId, id] as const,
    preliminariesByProject: (projectId: string) =>
        [...queryKeys.preliminaries, 'project', projectId] as const,
    operatives: ['operatives'] as const,
    operative: (id: string) => [...queryKeys.operatives, id] as const,
    costEntries: ['costEntries'] as const,
    taskCostEntries: () => [...queryKeys.costEntries, 'task'] as const,
    taskCostEntry: (projectId: string, taskId: string, id: string) =>
        [
            ...queryKeys.taskCostEntries(),
            'project',
            projectId,
            'task',
            taskId,
            id,
        ] as const,
    taskCostEntriesByTask: (projectId: string, taskId: string) =>
        [
            ...queryKeys.taskCostEntries(),
            'project',
            projectId,
            'task',
            taskId,
        ] as const,
    taskCostEntryDates: (
        projectId: string,
        startDate: DateOnly,
        endDate: DateOnly,
    ) =>
        [
            ...queryKeys.taskCostEntries(),
            'project',
            projectId,
            'dates',
            startDate,
            endDate,
        ] as const,
    taskCostEntriesByDate: (projectId: string, date: DateOnly) =>
        [
            ...queryKeys.taskCostEntries(),
            'project',
            projectId,
            'by-date',
            date,
        ] as const,
    preliminaryCostEntries: () =>
        [...queryKeys.costEntries, 'preliminary'] as const,
    preliminaryCostEntry: (
        projectId: string,
        preliminaryId: string,
        id: string,
    ) =>
        [
            ...queryKeys.preliminaryCostEntries(),
            'project',
            projectId,
            'preliminary',
            preliminaryId,
            id,
        ] as const,
    preliminaryCostEntriesByPreliminary: (
        projectId: string,
        preliminaryId: string,
    ) =>
        [
            ...queryKeys.preliminaryCostEntries(),
            'project',
            projectId,
            'preliminary',
            preliminaryId,
        ] as const,
    preliminaryCostEntryDates: (
        projectId: string,
        startDate: DateOnly,
        endDate: DateOnly,
    ) =>
        [
            ...queryKeys.preliminaryCostEntries(),
            'project',
            projectId,
            'dates',
            startDate,
            endDate,
        ] as const,
    preliminaryCostEntriesByDate: (projectId: string, date: DateOnly) =>
        [
            ...queryKeys.preliminaryCostEntries(),
            'project',
            projectId,
            'by-date',
            date,
        ] as const,
    externalCostEntries: ['externalCostEntries'] as const,
    externalCostEntry: (
        projectId: string,
        externalTaskId: string,
        id: string,
    ) =>
        [
            ...queryKeys.externalCostEntries,
            'project',
            projectId,
            'external-task',
            externalTaskId,
            id,
        ] as const,
    externalCostEntriesByProject: (projectId: string) =>
        [...queryKeys.externalCostEntries, 'project', projectId] as const,
    externalCostEntriesByExternalTask: (
        projectId: string,
        externalTaskId: string,
    ) =>
        [
            ...queryKeys.externalCostEntries,
            'project',
            projectId,
            'external-task',
            externalTaskId,
        ] as const,
    externalCostEntryDates: (
        projectId: string,
        startDate: DateOnly,
        endDate: DateOnly,
    ) =>
        [
            ...queryKeys.externalCostEntries,
            'project',
            projectId,
            'dates',
            startDate,
            endDate,
        ] as const,
    externalCostEntriesByDate: (projectId: string, date: DateOnly) =>
        [
            ...queryKeys.externalCostEntries,
            'project',
            projectId,
            'by-date',
            date,
        ] as const,
    externalTasks: ['externalTasks'] as const,
    externalTask: (projectId: string, id: string) =>
        [...queryKeys.externalTasks, 'project', projectId, id] as const,
    externalTasksByProject: (projectId: string) =>
        [...queryKeys.externalTasks, 'project', projectId] as const,
} as const;
